import { Helmet } from 'react-helmet';
import { useParams } from 'react-router-dom';
import { DraftContainer } from '../components/draft.container';
import { DraftSubPageLayout } from '../../../../../draft-sub-page-layout';
import { PageHeader } from '../../../../../../../shared/page-header';
import { getItem } from '../../../../../../../shared/local-storage';

interface IdentityDraftProps {}

export const IdentityDraft: React.FC<IdentityDraftProps> = () => {
  const applicantUserId = getItem('applicantUserId');
  const params = useParams();

  return (
    <DraftSubPageLayout
      header={
        <PageHeader
          title="Credential Verification for Health Professionals"
          subTitle="Request for Identity Verification"
          description="If you are unable to provide all information and documentation in one session, or if you leave the application for any reason, the information and documentation you provided will be saved for approximately 24 hours. After that time, it will no longer be available and you will be required to begin a new request."
        />
      }
    >
      <Helmet>
        <title>Case - Draft</title>
      </Helmet>
      <DraftContainer caseId={params.caseId ?? ''} applicantUserId={applicantUserId ?? ''} />
    </DraftSubPageLayout>
  );
};
